document.addEventListener("DOMContentLoaded", function () {
  const toast = document.getElementById("brandToast");
  const msg = document.getElementById("brandToastMsg");
  if (!toast || !msg) {
    return;
  }

  let timer;
  function showToast(text) {
    msg.textContent = text;
    toast.classList.add("is-visible");
    clearTimeout(timer);
    timer = setTimeout(() => toast.classList.remove("is-visible"), 1600);
  }

  document.querySelectorAll(".js-swatch").forEach((swatch) => {
    swatch.addEventListener("click", () => {
      const value = swatch.dataset.clipboard;
      const label = swatch.querySelector(".swatch__meta").textContent.trim();
      if (navigator.clipboard) {
        navigator.clipboard.writeText(value).then(
          () => showToast("Copied " + label),
          () => showToast(label)
        );
      } else {
        showToast(label);
      }
    });
  });
});
